module.exports = __webpack_public_path__ + "img/list2.a6db3a0f.png";